export default __webpack_public_path__ + "static/media/luz.577445c7.svg";